
export const TOKEN_IWrapId = Symbol('IWrapId');

export interface IWrapId {
    /**
     * Generates a unique ID using nanoid
     */
    generate(): string;
}